import { memo } from 'react';
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, type Edge, type EdgeProps } from '@xyflow/react';
import type { DataEdgeData } from '../lib/graph';

const colors: Record<string, string> = {
  event: '#17877c', identity: '#7651a3', commerce: '#b06d18', product: '#3d7a45', audience: '#a73c78', service: '#2d70a4', analytics: '#274c7d', governance: '#697274',
};

export const DataEdge = memo((props: EdgeProps<Edge<DataEdgeData>>) => {
  const [path, labelX, labelY] = getSmoothStepPath({
    sourceX: props.sourceX, sourceY: props.sourceY, targetX: props.targetX, targetY: props.targetY,
    sourcePosition: props.sourcePosition, targetPosition: props.targetPosition, borderRadius: 8, offset: 18,
  });
  const data = props.data;
  if (!data) return null;
  const color = colors[data.content.dataCategory];
  const classes = ['data-edge', `flow-${data.content.flowType}`, data.active ? 'is-active' : '', data.emphasized ? 'is-emphasized' : '', data.dimmed ? 'is-dimmed' : '', data.funnelMatch ? 'is-funnel-match' : 'is-funnel-muted'].filter(Boolean).join(' ');
  return (
    <g className={classes} style={{ color }}>
      <BaseEdge id={props.id} path={path} markerEnd={props.markerEnd} markerStart={props.markerStart} style={{ stroke: color }} />
      {data.active && !data.reducedMotion && (
        <>
          <circle r="5" fill={color} className="data-particle"><animateMotion dur="2.4s" repeatCount="indefinite" path={path} /></circle>
          <circle r="3" fill="#fff" stroke={color} strokeWidth="2" className="data-particle particle-delay"><animateMotion dur="2.4s" begin="-1.2s" repeatCount="indefinite" path={path} /></circle>
        </>
      )}
      <EdgeLabelRenderer>
        <span className="edge-label nodrag nopan" style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`, borderColor: color }}>
          {data.label}
        </span>
      </EdgeLabelRenderer>
    </g>
  );
});
DataEdge.displayName = 'DataEdge';
